/// <reference path="../models/country.ts" />

import {Country} from '../models/country'

export interface ICountryService {
    getCountryList(): Promise<any>
}

export class CountryService implements ICountryService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService
       
    ) {


    }

    getCountryList(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this._$http.get('/getCountries')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const countryList = response.data.map(s => new Country(s.countryCode, s.countryName));
                    resolve(countryList);
                });
        });
    }


}

angular
    .module('deliveryCreate.app')
    .service('countryService', CountryService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/services/countryService.ts
 **/